import './lib/modernizr.js';
import './plugins/jquery.slick.min.js';
import './plugins/jquery.countdownClock.min.js';
import './plugins/jquery.matchHeight.js';


import utils from './utils';
import slick from './slider-slick';
import countdownClock from './countdown-clock';
import matchHeight from './match-height';
import newsletter from './newsletter';

slick();
countdownClock();
matchHeight();
utils();
newsletter();


// WEBPACK FOOTER //
// ./src/assets/js/main.js